import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Edit Transaction", -1)
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "row horizontal-end" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Refund ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("td", null, "Created", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", null, "Amount", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", null, "Payment Method", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", null, "Customer", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", null, "Unit", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", null, "Status", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", null, "Authorization", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", null, "Account Summary", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", null, "Message", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", null, "Notes", -1)
const _hoisted_15 = { class: "form-field" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "customAmount" }, "Total Amount($)", -1)
const _hoisted_17 = {
  key: 0,
  class: "form-field"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", null, "Notes", -1)
const _hoisted_19 = {
  key: 1,
  class: "btn",
  type: "submit"
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Cancel ")

import { ref } from "vue";
import api from "@virgodev/bazaar/functions/api";
// const router = useRouter();
import { useRouter } from "vue-router";
import { useStore } from "@/store";
import { storeToRefs } from "pinia";

export default /*#__PURE__*/_defineComponent({
  props: {
  customerId: {
    type: Number,
    required: true,
  },
  transactionId: {
    type: Number,
    required: true,
  },
  customerName: {
    type: String,
    required: true,
  },
  facilityId: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

// import { useRouter } from "vue-router";
const formErrors = ref<Record<string, string[]>>({});
const formSubmitting = ref(false);

const router = useRouter();
const transaction = ref();
const store = useStore();
const { userData } = storeToRefs(store);
const api_settings = userData.value.chosenFacility.api_settings;

const formFields = ref({
  notes: ref(""),
});
// const lineItem = ref();
const errors = ref("");


async function submitForm() {
  const json = JSON.parse(JSON.stringify(formFields.value));

  formErrors.value = {};
  formSubmitting.value = true;
  let url = `transactions/?id=${props.transactionId}&facilityId=${props.facilityId}`;

  const responseData = await api({
    url,
    method: "PUT",
    json,
  });
  if ([200, 201].includes(responseData.status)) {
    if (api_settings.details_in_invoice) {
      router.push({
        name: "customer_detail_storedge",
        params: {
          id: props.customerId,
          facilityId: props.facilityId,
        },
      });
    } else {
      router.push({
        name: "customer_detail_ess",
        params: {
          id: props.customerId,
          facilityId: props.facilityId,
        },
      });
    }
  } else if (responseData.status === 400) {
    formErrors.value = responseData.body;
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your " +
          "connection and try again.",
      ],
    };
  }
}

async function getTransaction() {
  errors.value = "";
  const response = await api({
    url: `transactions/?id=${props.transactionId}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    transaction.value = response.body;
    formFields.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
getTransaction();

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_RouterLink, {
      to: {
      name: 'customer_detail_ess',
      params: { id: __props.customerId, facilityId: __props.facilityId },
    }
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Customer: " + _toDisplayString(__props.customerName), 1)
      ]),
      _: 1
    }, 8, ["to"]),
    _hoisted_1,
    (transaction.value)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          class: "large-width-centered",
          onSubmit: _withModifiers(submitForm, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_RouterLink, {
              class: "btn",
              to: {
          name: 'refund',
          params: {
            transactionId: __props.transactionId,
            customerId: __props.customerId,
            customerName: __props.customerName,
            facilityId: __props.facilityId,
          },
        }
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("table", null, [
            _createElementVNode("tr", null, [
              _hoisted_5,
              _createElementVNode("td", null, _toDisplayString(transaction.value.created_at), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_6,
              _createElementVNode("td", null, _toDisplayString(transaction.value.total), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_7,
              _createElementVNode("td", null, _toDisplayString(transaction.value.payment_method), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_8,
              _createElementVNode("td", null, _toDisplayString(__props.customerName), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_9,
              _createElementVNode("td", null, _toDisplayString(transaction.value.unit_names), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_10,
              _createElementVNode("td", null, _toDisplayString(transaction.value.status), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_11,
              _createElementVNode("td", null, _toDisplayString(transaction.value.authorization), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_12,
              _createElementVNode("td", null, _toDisplayString(transaction.value.account_summary), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_13,
              _createElementVNode("td", null, _toDisplayString(transaction.value.message), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_14,
              _createElementVNode("td", null, _toDisplayString(transaction.value.notes), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((transaction.value.total) = $event)),
              type: "decimal",
              required: "",
              disabled: ""
            }, null, 512), [
              [_vModelText, transaction.value.total]
            ])
          ]),
          (_unref(api_settings).update_line_item)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _hoisted_18,
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formFields.value.notes) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, formFields.value.notes]
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(api_settings).update_line_item)
            ? (_openBlock(), _createElementBlock("button", _hoisted_19, " Update Transaction "))
            : _createCommentVNode("", true),
          _createVNode(_component_RouterLink, {
            to: {
        name: 'customer_detail_ess',
        params: { id: __props.customerId, facilityId: __props.facilityId },
      },
            class: "btn btn-text"
          }, {
            default: _withCtx(() => [
              _hoisted_20
            ]),
            _: 1
          }, 8, ["to"])
        ], 40, _hoisted_2))
      : _createCommentVNode("", true)
  ], 64))
}
}

})